import { makeStyles } from '@material-ui/core';

export const compraRetencaoListStyles = makeStyles({
  buttonAdicionarRetencao: {
    color: '#53c4e6',
    fontSize: 15,
    marginTop: 8,
  },
});
